
import { AdminEventError } from '@/exceptions/admin-event/adminEvent.enum';
import { adminEventService } from '@/services/admin_event.service';
import { notificationService } from '@/services/notification.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useUpdateAdminEvent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ([eventId, event]: [number, FormData]) =>
            await adminEventService.editAdminEvent(eventId, event),

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['adminEvent'] });
            notificationService.success("event Updated Succesful");

        },

        onError: () => {
            throw new Error(AdminEventError.EDIT_ERROR);
        },
    });
};

export default useUpdateAdminEvent;
